// Hero card fan on the /topdecked partner landing page.
//
// UUIDs are Scryfall IDs resolved from the app's own card data via
// /cards/search-light (`name` + `exact=true`), each the only match for its
// name/set/collector number, and each confirmed to return 200 from the cards CDN
// at both 'normal' (hero fan) and 'small' (binder and match thumbnails). Image
// URLs are built at render time via AssetUrls.cards.getCardImage; we store
// identifiers, not URLs, so the fan survives any CDN URL-pattern change — the
// same convention as marqueeCards.ts.
//
// Deliberately NOT in constants/topdecked.ts: that module is the card-analytics
// and admin-ingest feature, and its display caps are kept byte-identical to the
// backend's src/services/topdecked/constants.ts. Marketing card art has no part
// in that cross-repo coupling.
//
// Resolving these by name is the load-bearing check, not the CDN 200: any valid
// Scryfall ID returns a perfectly good image, so a wrong-but-real UUID passes a
// status check while rendering the wrong card. Confirm the returned card's name,
// set and collector number before pasting an ID here.
export const HERO_CARD_IDS: readonly string[] = [
  'b2e2a777-0705-4a37-937d-c6e020ebc0f0', // Goblin Guide — Zendikar (zen) #126
  '7054012b-4f9d-44a0-aaf9-7fd3bddc7b2d', // Slickshot Show-Off — Outlaws of Thunder Junction (otj) #146
  'bd281158-8180-40b9-a5b7-03cfc712d81a', // Fury — Modern Horizons 2 (mh2) #126
];

/** Art thumbnail on the step-3 "match found" card. */
export const MATCH_CARD_ID = '60b2fae1-242b-45e0-a757-b1adc02c06f3'; // Lava Spike — Champions of Kamigawa (chk) #178
